import { render, staticRenderFns } from "./bulletinBoard.vue?vue&type=template&id=b60b651a"
import script from "./bulletinBoard.vue?vue&type=script&lang=js"
export * from "./bulletinBoard.vue?vue&type=script&lang=js"
import style0 from "./bulletinBoard.vue?vue&type=style&index=0&id=b60b651a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports